import React, { useRef, useLayoutEffect } from "react";
import * as whatWeDoCoverStyles from "./whatWeDoCover.module.scss";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const WhatWeDoCover = () => {
  const whatWeDoCoverSectionRef = useRef();
  const cirleVectorWrapperRef = useRef();
  const whatWeDoCoverTitleRef = useRef();

  const titleString = "What We Do?";

  const cirleVectorRef = useRef();

  useLayoutEffect(() => {
    const fadeInUpWhatWeDoTextAnimation = gsap.fromTo(
      `.WWD-coverTitleWrapper`,
      {
        opacity: 0,
        y: 100,
      },
      {
        opacity: 1,
        y: 0,
        duration: 1,
        scrollTrigger: {
          id: "what we do cover",
          trigger: whatWeDoCoverSectionRef.current,
          start: "top center",
          end: "top top",
          markers: false,
        },
      }
    );

    return () => {
      fadeInUpWhatWeDoTextAnimation.kill();
    };
  }, []);

  return (
    <section
      ref={whatWeDoCoverSectionRef}
      className={`es-section es-section__dark ${whatWeDoCoverStyles.whatWeDoCoverSection}`}
    >
      <div className={whatWeDoCoverStyles.whatWeDocontent}>
        <h2 className="WWD-coverTitleWrapper" ref={whatWeDoCoverTitleRef}>
          {titleString}
        </h2>
        <div
          className={whatWeDoCoverStyles.svgWrapper}
          ref={cirleVectorWrapperRef}
        >
          <svg
            ref={cirleVectorRef}
            width="1103"
            height="1103"
            viewBox="0 0 1103 1103"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M554.717 436.676V0H550.717V436.676H554.717ZM542.492 439.521L496.686 2.84507L492.708 3.26236L538.513 439.939L542.492 439.521ZM438.631 11.7955L530.242 439.311L526.331 440.149L434.72 12.6337L438.631 11.7955ZM517.976 442.168L383.614 26.8675L379.808 28.0988L514.17 443.399L517.976 442.168ZM328.573 48.0492L505.686 448.081L502.029 449.701L324.915 49.6686L328.573 48.0492ZM496.427 450.941L276.562 72.2841L273.102 74.2926L492.967 452.949L496.427 450.941ZM230.64 105.699L487.15 456.873L483.92 459.232L227.41 108.059L230.64 105.699ZM477.857 465.871L184.703 142.18L181.738 144.866L474.892 468.556L477.857 465.871ZM144.866 181.739L468.556 474.892L465.871 477.857L142.181 184.703L144.866 181.739ZM459.232 483.92L108.059 227.411L105.699 230.641L456.873 487.15L459.232 483.92ZM74.2933 273.102L452.95 492.967L450.941 496.426L72.2848 276.561L74.2933 273.102ZM449.701 502.029L49.6691 324.915L48.0497 328.573L448.082 505.686L449.701 502.029ZM28.0981 379.807L443.399 514.169L442.167 517.975L26.8668 383.613L28.0981 379.807ZM440.149 526.331L12.6339 434.721L11.7958 438.632L439.311 530.243L440.149 526.331ZM3.26138 492.707L439.938 538.513L439.521 542.491L2.84409 496.686L3.26138 492.707ZM436.676 550.716H0V554.716H436.676V550.716ZM2.84409 608.747L439.521 562.942L439.938 566.92L3.26138 612.725L2.84409 608.747ZM439.311 572.136L11.7958 663.747L12.6339 667.658L440.149 576.048L439.311 572.136ZM26.8668 718.766L442.167 584.404L443.399 588.21L28.0981 722.572L26.8668 718.766ZM448.082 596.693L48.0497 773.807L49.6691 777.464L449.701 600.351L448.082 596.693ZM72.2848 825.818L450.941 605.953L452.95 609.412L74.2933 829.277L72.2848 825.818ZM456.873 618.282L105.699 874.791L108.059 878.021L459.232 621.512L456.873 618.282ZM142.189 917.669L465.879 627.569L468.548 630.548L144.858 920.647L142.189 917.669ZM474.885 633.83L181.732 960.574L184.709 963.245L477.863 636.501L474.885 633.83ZM227.406 997.381L483.915 643.154L487.155 645.5L230.645 999.727L227.406 997.381ZM492.967 649.43L273.102 1028.09L276.562 1030.1L496.427 651.439L492.967 649.43ZM324.918 1052.7L502.031 655.726L505.684 657.356L328.571 1054.33L324.918 1052.7ZM514.17 658.979L379.808 1074.28L383.614 1075.51L517.976 660.211L514.17 658.979ZM434.72 1089.74L526.331 662.23L530.242 663.068L438.631 1090.58L434.72 1089.74ZM538.514 665.492L492.708 1099.11L496.686 1099.54L542.491 665.912L538.514 665.492ZM550.717 1102.38V665.702H554.717V1102.38H550.717ZM562.941 665.899L605.693 1099.52L609.674 1099.13L566.922 665.506L562.941 665.899ZM663.747 1090.58L572.136 663.068L576.047 662.23L667.658 1089.74L663.747 1090.58ZM584.404 660.211L718.766 1075.51L722.572 1074.28L588.21 658.979L584.404 660.211ZM773.809 1054.33L596.695 657.356L600.348 655.726L777.461 1052.7L773.809 1054.33ZM605.952 651.439L825.817 1030.1L829.276 1028.09L609.411 649.43L605.952 651.439ZM874.786 999.727L618.277 645.5L621.516 643.154L878.026 997.381L874.786 999.727ZM627.563 636.494L917.663 963.238L920.654 960.582L630.554 633.838L627.563 636.494ZM960.582 920.654L633.838 630.554L636.494 627.563L963.238 917.662L960.582 920.654ZM643.153 621.517L997.38 878.026L999.726 874.787L645.499 618.277L643.153 621.517ZM1028.09 829.277L649.429 609.412L651.438 605.953L1030.09 825.818L1028.09 829.277ZM655.726 600.348L1052.7 777.462L1054.33 773.809L657.356 596.695L655.726 600.348ZM1074.28 722.572L658.98 588.21L660.211 584.404L1075.51 718.766L1074.28 722.572ZM662.229 576.048L1089.74 667.658L1090.58 663.747L663.068 572.136L662.229 576.048ZM1099.12 612.725L665.493 566.92L665.913 562.942L1099.54 608.747L1099.12 612.725ZM665.703 554.716H1102.38V550.716H665.703V554.716ZM1099.54 496.685L665.913 542.491L665.493 538.513L1099.12 492.708L1099.54 496.685ZM663.068 530.243L1090.58 438.632L1089.74 434.721L662.229 526.331L663.068 530.243ZM1075.51 383.613L660.211 517.975L658.98 514.169L1074.28 379.807L1075.51 383.613ZM657.356 505.684L1054.33 328.57L1052.7 324.917L655.726 502.031L657.356 505.684ZM1030.09 276.561L651.438 496.426L649.429 492.967L1028.09 273.102L1030.09 276.561ZM645.499 487.155L999.726 230.646L997.38 227.406L643.153 483.915L645.499 487.155ZM963.246 184.71L636.502 477.863L633.83 474.886L960.574 181.732L963.246 184.71ZM630.548 468.548L920.648 144.858L917.669 142.188L627.569 465.878L630.548 468.548ZM878.021 108.059L621.512 459.232L618.281 456.873L874.791 105.699L878.021 108.059ZM609.411 452.949L829.276 74.2926L825.817 72.2841L605.952 450.941L609.411 452.949ZM777.464 49.6686L600.35 449.701L596.693 448.081L773.806 48.0492L777.464 49.6686ZM588.21 443.399L722.572 28.0988L718.766 26.8675L584.404 442.168L588.21 443.399ZM667.658 12.6337L576.047 440.149L572.136 439.311L663.747 11.7955L667.658 12.6337ZM566.922 439.925L609.674 3.24858L605.693 2.85884L562.941 439.535L566.922 439.925Z"
              fill="url(#paint0_linear_597_29)"
            />
            <defs>
              <linearGradient
                id="paint0_linear_597_29"
                x1="551.19"
                y1="0"
                x2="551.19"
                y2="1102"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#0066CC" />
                <stop offset="0.565625" stopColor="#EB3300" />
                <stop offset="1" stopColor="#EB8D00" />
              </linearGradient>
            </defs>
          </svg>
        </div>
      </div>
    </section>
  );
};

export default WhatWeDoCover;
